export function sleep(ms: number) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export function singleFlight<T>(factory: () => Promise<T>): () => Promise<T> {
	let promise: Promise<T> | null = null;

	return () => {
		if (promise) {
			return promise;
		}

		promise = factory().catch((err) => {
			promise = null;
			throw err;
		});

		return promise;
	};
}
